module.exports = __webpack_public_path__ + "img/HR.b12c6195.svg";